/* eslint-disable react/prop-types */
import * as React from 'react';
import { I18nContext } from './context';
var Provider = I18nContext.Provider;
export var I18nProvider = function I18nProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children);
};